import React, { createContext, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Radio, Select, Input, Col, Row, Form, Space, Tag, message } from "antd";
import { Option } from "antd/lib/mentions";
import "../Tab/Filter.css";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/actions/leads";
import { stoageGetter, checkPartnerUser} from "../../helpers";

const leadStatus = [
  { label: "Interested", value: "Interested" },
  { label: "Not Interested", value: "Not Interested" },
  { label: "Not Contactable", value: "Not Contactable" },
];

const SourceByoption = [
  { label: "Self Sourced", value: "Self Sourced" },
  { label: "LSQ", value: "LSQ", disabled: true },
];

const lead_type = [
  { label: "New Business", value: "New Business" },
  // {label: 'LA Recruitment', value: 'LA Recruitment',},
  // {label: 'OP Recruitment', value: 'OP Recruitment',},
];

// const otp_type = [
//   {label: 'OTP Verified', value: 'OTP Verified'},
//   {label: 'OTP Non-Verified', value: 'OTP Non-Verified'}
// ]

const leadDisposition = [
  { label: "Not Reachable", value: "notreachable" },
  { label: "Ringing Busy", value: "ringingbusy" },
  { label: "Wrong Number", value: "wrongnumber" },
  { label: "Invalid Number", value: "invalidnumber" },
  { label: "Switched Off", value: "switchedoff" },
];

const lead_Disposition_contact = [
  { label: "Appointment", value: "appointment" },
  { label: "Call back", value: "callback" },
  { label: "Short hang-up", value: "shorthangup" },
  { label: "Not Interested", value: "notinterested" },
  { label: "Non Serviceable", value: "nonserviceable" },
  { label: "Not eligible", value: "noteligible" },
  { label: "Language Barrier", value: "languagebarrier" },
  { label: "Spot Closure", value: "spotclosure" },
  { label: "Converted", value: "converted" },
  { label: "Failed", value: "failed" },
];

const leadDispositionOptionContactLa = [
  { value: "bop", label: "BOP" },
  { value: "appointment", label: "Appointment" },
  {
    value: "callback",
    label: "Call back",
  },

  {
    value: "shorthangup",
    label: "Short hang-up",
  },
  {
    value: "notinterested",
    label: "Not Interested",
  },

  {
    value: "noteligible",
    label: "Not eligible",
  },

  {
    value: "languagebarrier",
    label: "Language Barrier",
  },

  {
    value: "converted",
    label: "Converted",
  },

  {
    value: "failed",
    label: "Failed",
  },

  {
    value: "training",
    label: "Training",
  },
  {
    value: "exam",
    label: "Exam",
  },
  {
    value: "coding",
    label: "Coding",
  },
];

let filterPayload = {};
export function OffCanvasForGlobalFilter({ subsourceArr, ...props }) {
  // //console.log("PROPS FILTER DATA____________________>", props);
  // //console.log("PROPS FILTER DATA+++++++++++++++++++++++++++++++>", props?.subsourceArr);

  const { id } = stoageGetter("user");
  const dispatch = useDispatch();
  const location = useLocation();
  //console.log("Location______________>", location);
  // const subSourceArr = props?.subsourceArr;
  const subSrcData = useSelector((state) => state?.subSource?.subSource);
  //console.log("subSrcData++++++++++++++++++++++",subSrcData)
  // const subsourcearr = subSourceArr?.map((item)=>{
  //   //console.log("item+++++++++++++++++++++++++++++++++>",item)
  // })

  // //console.log("subsourceArr+++++++++++++++++++++++++++++",subsourcearr)
  // {
  //   label: lead_data.label,
  //   value: lead_data.value,
  // }
  const checkData = () => {
    if (location?.state == "self") {
      return (filterPayload = {
        id: id,
        skip: 0,
        searchtxt: "",
        leadStatus: "",
        sortByFlter: "",
        sort_status: "",
        leadfilter: "all",
        leadDisposition: "",
        leadType: "",
        searchType: "",
        source: "",
      });
    } else if (location?.state == "LSQ") {
      return (filterPayload = {
        id: id,
        skip: 0,
        searchtxt: "",
        leadStatus: "",
        sortByFlter: "",
        sort_status: "",
        leadfilter: "all",
        leadDisposition: "",
        leadType: "",
        searchType: "",
        source: "",
        subSource: "",
      });
    } else {
      return (filterPayload = {
        id: id,
        skip: 0,
        searchtxt: "",
        leadStatus: "",
        sortByFlter: "",
        sort_status: "",
        leadfilter: "all",
        leadDisposition: "",
        leadType: "",
        searchType: "fname",
        source: "",
      });
    }
  };

  const [filterData, setFilterData] = useState(checkData());

  useEffect(() => {
    if (checkPartnerUser()) {
      setSelectedSource("LSQ");
      setFilterData((res) => ({ ...res, sourceBy: "LSQ" }));
    }
  }, []);

  // searchtxt:'', leadStatus:'', sorByFlter:'', sort_status:'', leadfilter, leadDisposition, leadType

  const [searchTextFilter, setSearchTextFilter] = useState("");
  const [sortByFlter, setSortByFlter] = useState("");

  const [shortByStatus, setShortByStatus] = useState("created_date_old");
  const [sortBy, setSortBy] = useState("new_to_old");

  // const [leadFilter, setleadFilter] = useState("");
  // const [searchType, setSearchType] = useState("fname");

  // const [leadDisposition, setLeadDisposition] = useState("");
  // const [leadType, setLeadType] = useState("");
  //const [leadStatus, setLeadStatus] = useState("");

  const [otpFilter, setOTPFilter] = useState([]);
  const [closetab, setCloseTab] = useState(false);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedSourceOnLoad, setSelectedSourceOnLoad] = useState(null);
  const [subSourceData, setSubSourceData] = useState(null);
  // let sortByData = [
  //   {label:'Lead Created date - Newest to oldest',value:'new_to_old', status: 'created_date_old'},
  //   {label:'Lead Created date - Oldest to Newest',value:'old_to_new', status: 'created_date_new'},
  //   // {label:'Allocation Date - Newest to Oldest',value:'new_to_old', status: 'allocation_date_old'},
  //   // {label:'Allocation Date - Oldest to Newest',value:'old_to_new', status: 'allocation_date_new'},
  // ]

  //console.log("DATACHECK++++++++++++++++++++++++",subSourceData)
  let sortByData = [
    {
      label: "Lead Creation date - Newest to Oldest",
      status: "new_to_old",
      filtValue: "createddate",
      value: "created_date_old",
    },
    {
      label: "Lead Creation date - Oldest to Newest",
      status: "old_to_new",
      filtValue: "createddate",
      value: "created_date_new",
    },
    {
      label: "Lead Allocation Date - Newest to Oldest",
      status: "new_to_old",
      filtValue: "allocateddate",
      value: "allocation_date_old",
    },
    {
      label: "Lead Allocation Date - Oldest to Newest",
      status: "old_to_new",
      filtValue: "allocateddate",
      value: "allocation_date_new",
    },
  ];

  const handleSortByStatus = (ev, data) => {
    setFilterData((res) => ({ ...res, sortByFlter: data.filtValue }));
    setFilterData((res) => ({ ...res, sort_status: data.status }));
    setShortByStatus(data);
  };

  const handleChange = (val) => {
    setFilterData((res) => ({ ...res, leadType: val }));
  };

  const handleSearchType = (val) => {
    setFilterData((res) => ({ ...res, searchType: val.target.value }));
    //console.log("--- name", val);
  };

  const handleNameSearch = (val) => {
    setFilterData((res) => ({ ...res, searchtxt: val.target.value }));
  };

  const handleLeadDispositionChange = (val) => {
    setFilterData((res) => ({ ...res, leadDisposition: val }));
  };
  const handleLeadStatusChange = (val) => {
    setFilterData((res) => ({ ...res, leadStatus: val }));
  };
  const handlesourceByChange = (val) => {
    //console.log("VAlue----->", val);
    setSelectedSource(val);
    setFilterData((res) => ({ ...res, sourceBy: val }));
  };

  const handlesourceByChangeSubSrc = (val) => {
    //console.log("VAlue----->", val);
    // if (selectedSource == "" || selectedSource == null || selectedSource == undefined) {
    //   return message.warning("Please select Source By.");
    // }
    if (!selectedSource && !checkPartnerUser) {
      return message.warning("Please select Source By.");
    }
    setSubSourceData(val);
    setFilterData((res) => ({ ...res, subSource: val }));
  };

  const [hitFilterAPI, setHitFilterAPI] = useState(false);

  useEffect(() => {
    dispatch(
      actions.fetchDataAfterFilter(
        filterData.id,
        filterData.skip,
        filterData.searchtxt,
        filterData.leadStatus,
        filterData.sortByFlter,
        filterData.sort_status,
        filterData.leadfilter,
        filterData.leadDisposition,
        filterData.leadType,
        filterData.searchType,
        filterData.sourceBy,
        filterData.source,
        filterData.subSource
      )
    );

    //console.log("filterData.source=================================>",filterData.source)
    setSelectedSourceOnLoad(filterData.source);
    // setFilterData(res => ({...res,sourceBy:filterData.source}))
    if (
      filterData.searchtxt === "" &&
      filterData.leadType === "" &&
      filterData.leadStatus === "" &&
      filterData.leadDisposition === "" &&
      filterData.sort_status === "" &&
      filterData.sortByFlter === "" &&
      filterData.sourceBy === "" &&
      filterData.source === ""
    ) {
      setCloseTab(false);
    }
  }, [hitFilterAPI]);

  const handleApplyButton = () => {
    dispatch(
      actions.fetchDataAfterFilter(
        filterData.id,
        filterData.skip,
        filterData.searchtxt,
        filterData.leadStatus,
        filterData.sortByFlter,
        filterData.sort_status,
        filterData.leadfilter,
        filterData.leadDisposition,
        filterData.leadType,
        filterData.searchType,
        filterData.sourceBy,
        filterData.source,
        filterData.subSource
      )
    );
    setCloseTab(true);
    handleClose();
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 200;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    // setShow(props.show);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  const checkURL = () => {
    return width < 620 ? ["/leadMaster"].some((path) => window.location.pathname.includes(path)) : false;
  };

  return (
    <>
      <figure
        className="round-cards43"
        onClick={handleShow}
        role="button"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleShow();
          }
        }}
        key={"filter"}
      >
        <figcaption className="card-caption">Filter</figcaption>
      </figure>

      {closetab && document.body ? createPortal(
        <>
          <div className="tagsss">
            <p>Selected Filters:</p>
            <div className="filter_chip">
              <ul>
                <li>
                  {filterData.searchtxt ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, searchtxt: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.searchtxt}
                    </Tag>
                  ) : null}
                </li>
                <li>
                  {filterData.leadType ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, leadType: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.leadType}
                    </Tag>
                  ) : null}
                </li>
                <li>
                  {filterData.leadStatus ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, leadStatus: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.leadStatus}
                    </Tag>
                  ) : null}
                </li>

                <li>
                  {filterData.sourceBy ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, sourceBy: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.sourceBy}
                    </Tag>
                  ) : null}
                </li>
                <li>
                  {filterData.source && filterData.source !== "" ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, source: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.source}
                    </Tag>
                  ) : null}
                </li>
                {/* ---------------------------SubSource------------------------------- */}
                <li>
                  {filterData.subSource ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({ ...res, subSource: "" }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.subSource}
                    </Tag>
                  ) : null}
                </li>
                <li>
                  {filterData.leadDisposition ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({
                          ...res,
                          leadDisposition: "",
                        }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.leadDisposition}
                    </Tag>
                  ) : null}
                </li>
                <li>
                  {filterData.sortByFlter || filterData.sort_status ? (
                    <Tag
                      closable
                      color="rgb(0 172 193)"
                      backgroundColor="rgb(1 180 187)"
                      onClose={(e) => {
                        setFilterData((res) => ({
                          ...res,
                          sortByFlter: "",
                          sort_status: "",
                        }));
                        setHitFilterAPI(!hitFilterAPI);
                      }}
                    >
                      {filterData.sortByFlter} {filterData.sort_status}
                    </Tag>
                  ) : null}
                </li>
              </ul>
            </div>
          </div>
        </>,
        document.body
      ) : null}

      {checkURL() ? (
        <figure
          style={
            !(breakpoint <= width)
              ? {
                  position: "fixed",
                  bottom: "8%",
                  zIndex: "99999",
                  boxShadow: "0px 0px 4px 1px black",
                  right: "5.5%",
                  transform: "scale(0.9)",
                }
              : {}
          }
          className="round-cards43"
          onClick={handleShow}
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleShow();
            }
          }}
          key={"filter"}
        >
          {" "}
          {checkURL() ? width < breakpoint ? <figcaption className="card-caption">Filter</figcaption> : null : null}
        </figure>
      ) : null}

      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        scroll={true}
        placement={breakpoint <= width ? "end" : "down"}
        style={{
          width: breakpoint <= width ? "27rem" : "100%",
          height: "auto",
          marginTop: "3.7rem",
          backgroundColor: "rgb(247, 247, 247)",
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Select Filter</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{
              width: "auto",
              height: "6rem",
              backgroundColor: "white",
              marginBottom: "0.5rem",
            }}
          >
            <h6
              style={{
                fontWeight: "bold",
                padding: "10px",
                fontSize: "13px",
                marginLeft: 5,
              }}
            >
              Sort by
            </h6>
            <Select
              onChange={(ev, data) => handleSortByStatus(ev, data)}
              bordered={false}
              name="SortBy"
              value={shortByStatus}
              options={sortByData}
              style={{
                width: "22rem",
                marginLeft: "1rem",
                // marginTop: "1rem",
                borderBottom: "1px gray solid",
                opacity: "0.5",
              }}
            ></Select>
          </div>
          <div
            style={{
              width: "auto",
              height: "10rem",
              backgroundColor: "white",
              marginBottom: "0.5rem",
            }}
          >
            <h6 style={{ fontWeight: "bold", padding: "10px", fontSize: "13px" }}>Search Type Selection</h6>
            <Radio.Group
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "1rem",
              }}
              // onChange={handleSearchType}
              // defaultValue="fname"
              buttonStyle="solid"
            >
              <Space>
                <Radio.Button value="fname" onChange={handleSearchType}>
                  Name
                </Radio.Button>
                <Radio.Button value="primaryMobile" onChange={handleSearchType}>
                  Mobile
                </Radio.Button>
                <Radio.Button value="lead_Id" onChange={handleSearchType}>
                  Lead ID
                </Radio.Button>
              </Space>
            </Radio.Group>
            <div style={{ marginLeft: "20px" }}>{filterData.searchType === "fname" ? <p>Name</p> : filterData.searchType === "primaryMobile" ? <p>Mobile </p> : filterData.searchType === "lead_Id" ? <p>Lead ID</p> : null}</div>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Input
                  type="text"
                  placeholder={
                    filterData.searchType === "fname" ? "Enter the Lead’s First or Last Name " : filterData.searchType === "primaryMobile" ? "Enter the Lead’s Mobile Number" : filterData.searchType === "lead_Id" ? "Enter the Lead’s ID" : ""
                  }
                  size="default"
                  onChange={handleNameSearch}
                  style={{
                    width: "93%",
                    margin: "-10px 15px",
                    borderBottom: "1px gray solid",
                    opacity: "0.5",
                  }}
                  bordered={false}
                />
              </Col>
            </Row>
          </div>

          <div style={{ width: "auto", height: "11rem", backgroundColor: "white" }}>
            <h6
              style={{
                fontWeight: "bold",
                padding: "10px",
                fontSize: "13px",
                marginLeft: 5,
              }}
            >
              Filter by
            </h6>
            <Row>
              <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                <div className="filterby">
                  <h6>Source By</h6>       
                  {checkPartnerUser() ? (
                    <Select
                      defaultValue="Select"
                      value={filterData.sourceBy || "Select"}
                      style={{
                        width: "100%",
                        borderBottom: "1px gray solid",
                        opacity: "0.5",
                      }}
                      onChange={handlesourceByChange}
                      options={SourceByoption?.map((lead_data) => ({
                        label: lead_data.label,
                        value: lead_data.value,
                        disabled: lead_data.value === "LSQ" ? !checkPartnerUser() : lead_data.disabled,
                      }))}
                      bordered={false}
                    />
                  ) : (
                      <Select
                        defaultValue="All"
                        value={filterData.source === "" ? "All" : filterData.source}
                        style={{
                          width: "100%",
                          borderBottom: "1px gray solid",
                          opacity: "0.5",
                        }}
                        onChange={(val) => {
                          const resultVal = val === "All" ? "" : val;
                          setSelectedSource(resultVal);
                          setFilterData((res) => ({ ...res, source: resultVal }));
                        }}
                        options={[
                          { label: "All", value: "All" },
                          { label: "LSQ", value: "LSQ" },
                          { label: "DSO", value: "DSO" }
                        ]}
                        bordered={false}
                      />
                  )}
                </div>
              </Col>

              {/* ----------------------------Sub source by-------------------------- */}

              {/* {selectedSource == "LSQ" || selectedSourceOnLoad == "LSQ" ? (
                <> */}
                  <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                    <div className="filterby">
                      <h6>Sub Source By</h6>
                      <Select
                        defaultValue="Select"
                        style={{
                          width: "100%",
                          borderBottom: "1px gray solid",
                          opacity: "0.5",
                        }}
                        onChange={handlesourceByChangeSubSrc}
                        options={subSrcData}
                        bordered={false}
                      />
                    </div>
                  </Col>
              {/* </>
              ) : null} */}
            </Row>
            <Row>
              <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                <div className="filterby">
                  <h6>Lead Type</h6>
                  <Select
                    defaultValue="Select"
                    style={{
                      width: "100%",
                      borderBottom: "1px gray solid",
                      opacity: "0.5",
                    }}
                    onChange={handleChange}
                    options={lead_type?.map((lead) => ({
                      label: lead.label,
                      value: lead.value,
                    }))}
                    bordered={false}
                  />
                </div>
              </Col>
              <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                <div className="filterby">
                  <h6>Lead Status</h6>
                  <Select
                    defaultValue="Select"
                    style={{
                      width: "100%",
                      borderBottom: "1px gray solid",
                      opacity: "0.5",
                    }}
                    onChange={handleLeadStatusChange}
                    options={leadStatus?.map((lead_data) => ({
                      label: lead_data.label,
                      value: lead_data.value,
                    }))}
                    bordered={false}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                {filterData.leadStatus === "nocontact" ? (
                  <div className="filterby">
                    <h6>Lead Disposition</h6>
                    <Select
                      defaultValue="select"
                      style={{
                        width: "100%",
                        borderBottom: "1px gray solid",
                        opacity: "0.5",
                      }}
                      onChange={handleLeadDispositionChange}
                      options={leadDisposition?.map((lead_di) => ({
                        label: lead_di.label,
                        value: lead_di.value,
                      }))}
                      bordered={false}
                    />
                  </div>
                ) : (
                  ""
                )}

                {filterData.leadType === "Sales" && filterData.leadStatus === "contact" ? (
                  <div className="filterby">
                    <h6>Lead Disposition</h6>
                    <Select
                      defaultValue="select"
                      style={{
                        width: "100%",
                        borderBottom: "1px gray solid",
                        opacity: "0.5",
                      }}
                      onChange={handleLeadDispositionChange}
                      options={lead_Disposition_contact?.map((lead_di) => ({
                        label: lead_di.label,
                        value: lead_di.value,
                      }))}
                      bordered={false}
                    />
                  </div>
                ) : (
                  ""
                )}

                {(filterData.leadType === "LA Recruitment" || filterData.leadType === "OP Recruitment") && filterData.leadStatus === "contact" ? (
                  <div className="filterby">
                    <h6>Lead Disposition</h6>
                    <Select
                      defaultValue="select"
                      style={{
                        width: "100%",
                        borderBottom: "1px gray solid",
                        opacity: "0.5",
                      }}
                      onChange={handleLeadDispositionChange}
                      options={leadDispositionOptionContactLa?.map((lead_di_LA) => ({
                        label: lead_di_LA.label,
                        value: lead_di_LA.value,
                      }))}
                      bordered={false}
                    />
                  </div>
                ) : (
                  ""
                )}
              </Col>
              {/* <Col xs={24} sm={12} md={24} lg={12} xl={12}>
                {leadStatus === 'new_lead' ? null : <div className="filterby">
                <h6>Lead Sub Disposition</h6>
                <Select
                            defaultValue="Select"
                            onChange={handleLeadSubDispositionChange}
                            options={lead_sub_dis}
                            style={{width: '100%'}}
                        />
              </div>
              }

              </Col> */}
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                style={{
                  marginTop: "15px",
                  width: "6rem",
                  backgroundColor: "rgb(59, 55, 30)",
                  color: "#fff",
                  marginBottom: "10px",
                }}
                onClick={handleApplyButton}
              >
                Apply
              </Button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function GlobalFilters(props) {
  //console.log("PROPS+++++++++++++++++++===========+++++++++++++++++>",props)

  return (
    <>
      <OffCanvasForGlobalFilter key={"0"} filterdata={props} subsourceArr={props.subSourceArr} />
    </>
  );
}

export default GlobalFilters;
